<template>
  <div class="appmessages">
    <div
      v-for="item in l_items"
      :key="item.id"
      class="appmessages_item"
      :class="`appmessages_item_${item.type.toLowerCase()}`"
      :style="item.cssStyle || ''"
    >
      <slot> <div v-html="item.message"></div> </slot>

      <div
        v-if="item.linkUrl || item.routerLinkProps || item.gwBtnProps"
        class="appmessages_btn_container"
        @click="
          () => {
            if (item.btnFn) {
              item.btnFn(item)
            }
            close(item)
          }
        "
      >
        <div
          v-if="item.gwBtnProps"
          v-bind="item.gwBtnProps"
          class="gw_btn appmessages_btn text-nowrap weight_500 gw_btn_primary clr-white"
        >
          <i
            v-if="item.linkIcon"
            class="mdi mr-2 text-semi-large"
            :class="item.linkIcon"
          ></i>
          {{ item.linkText }}
        </div>
        <router-link
          v-else-if="item.routerLinkProps"
          v-bind="item.routerLinkProps"
          class="gw_btn appmessages_btn text-nowrap weight_500 gw_btn_primary clr-white"
        >
          <i
            v-if="item.linkIcon"
            class="mdi mr-2 text-semi-large"
            :class="item.linkIcon"
          ></i>
          {{ item.linkText }}
        </router-link>
        <a
          v-else
          class="gw_btn appmessages_btn text-nowrap weight_500 gw_btn_primary clr-white"
          :href="item.linkUrl"
          target="_blank"
        >
          <i
            v-if="item.linkIcon"
            class="mdi mr-2 text-semi-large"
            :class="item.linkIcon"
          ></i>
          {{ item.linkText }}
        </a>
      </div>
      <div
        class="mdi mdi-close icon_btn appmessages_item_close"
        @click="close(item)"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppMessages',
  props: {
    // items: { default: () => [] },
  },
  data() {
    return {
      l_items: [],
    }
  },
  methods: {
    initialize() {
      let appMessagesIds = []
      this.l_items = this.items
      try {
        appMessagesIds = JSON.parse(localStorage.getItem('appMessagesIds') || '[]')
        this.l_items = this.l_items.filter(item => !appMessagesIds.includes(item.id))
      } catch (error) {
        //
      }
    },
    close(item) {
      this.l_items = this.l_items.filter(i => i.id !== item.id)
      const appMessagesIds = this.items
        .filter(i => this.l_items.every(ii => ii.id !== i.id))
        .map(i => i.id)
      localStorage.setItem('appMessagesIds', JSON.stringify(appMessagesIds))
    },
  },
  computed: {
    items() {
      return this.$store.getters.appMessages
    },
  },
  // created() {  initialize() },
  watch: {
    items: {
      handler: 'initialize',
      immediate: true,
    },
  },
}
</script>

<style lang="scss">
.appmessages {
  position: fixed;
  width: 100vw;
  top: 0;
  left: 0;
  z-index: 99;
  display: flex;
  flex-direction: column;
  &_btn_container {
    margin: 0 0 0 auto;
  }
  &_item {
    flex: 1;
    min-height: 3rem;
    position: relative;
    --clr-main: grey;
    padding: 0.25rem 3rem 0.25rem 1rem;
    background: var(--clr-black-0);
    z-index: 1;
    display: flex;
    align-items: center;
    font-size: 1rem;
    font-weight: 500;
    border-top: 1px solid var(--clr-black-1);
    &:nth-child(1) {
      border-top: none;
    }
    &_close {
      font-size: 1.25rem;
      position: absolute !important;
      right: 0.25rem;
      top: 0.25rem;
      padding: 0.5rem;
    }
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: var(--clr-main);
      opacity: 0.75;
      z-index: -1;
    }
    &_info {
      --clr-main: linear-gradient(90deg, var(--clr-blue-1), black 180%);
      // --clr-main: linear-gradient(90deg, var(--clr-primary), black 180%);
      // --clr-main: linear-gradient(90deg, var(--clr-error), black 180%);
      // --clr-main: linear-gradient(90deg, var(--clr-yellow), black 180%);
    }
    &_announcement {
      --clr-main: linear-gradient(90deg, var(--clr-primary), black 180%);
    }
    &_analyzer_offline {
      --clr-main: linear-gradient(90deg, var(--clr-error), black 180%);
    }
    &_warning {
      --clr-main: linear-gradient(90deg, var(--clr-yellow), black 180%);
    }
    &_error {
      --clr-main: linear-gradient(90deg, var(--clr-error), black 180%);
    }
  }
}

@media (max-width: 1023px) {
  .appmessages {
    &_item {
      padding: 1rem;
      flex-direction: column;
    }
    &_btn_container {
      margin: 0.5rem auto 0 0;
    }
  }
}
</style>
